<template>
  <div class="problem">
    <div class="topTitle">
      <span @click="goback">返回</span> / {{ $route.query.title }}
    </div>
    <div class="mian">
      <div class="clearfix top">
        <div class="fl" style="margin-right:10px">
          <el-form ref="form" :model="form" :inline="true" size="mini">
            <el-form-item label="标题">
              <el-input v-model="form.title" prefix-icon="el-icon-search" placeholder="请输入标题" size="mini" clearable></el-input>
            </el-form-item>
          </el-form>
        </div>

        <div class="fl">
          <el-button type="primary" @click="search" icon="el-icon-search" size="mini">查询</el-button>

          <el-button type="primary" @click="AddTopicAnalysis" icon="el-icon-plus" size="mini">新增题解</el-button>
        </div>
      </div>
      <el-divider></el-divider>

      <el-table :data="tableData" size="mini" stripe style="width: 100%;margin-top: 20px;" :header-cell-style="{ background: '#f5f7fa' }">
        <el-table-column prop="title" label="标题"> </el-table-column>
        <el-table-column label="类型">
          <template slot-scope="scope">
            <span v-if="scope.row.sort_type === 1">官方</span>
            <span v-if="scope.row.sort_type === 2">精选</span>
            <span v-if="scope.row.sort_type === 3">普通</span>
          </template>
        </el-table-column>
        <el-table-column prop="" label="语言">
          <template slot-scope="scope">
            <span v-for="item in JSON.parse(scope.row.languages)" :key="item">
              <span v-if="item === '0'"> C </span>
              <span v-if="item === '1'"> C++ </span>
              <span v-if="item === '2'"> Python3 </span>
            </span>
          </template>
        </el-table-column>

        <el-table-column label="是否可见">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.visible" active-color="#409EFF" inactive-color="#ccc" @change="changeType(scope.row)">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="edit(scope.row)">编辑</el-button>
            <el-button type="text" size="mini" @click="del(scope.row)">删除</el-button>
            <el-button type="text" size="mini" @click="editType(scope.row)">更新类型</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin: 20px; text-align: right">
        <el-pagination @current-change="handleCurrent" :current-page="page_no" :page-size="page_size" layout="total, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
    <el-dialog :title="dialogTitle" z-index="1000" :visible.sync="dialogVisible" width="80%" @close="closeDialog('addForm')">
      <el-form ref="addForm" :model="addForm" :rules="rules" size="small" label-width="80px">
        <el-form-item label="题解标题" prop="title" required>
          <el-input v-model="addForm.title" clearable placeholder="请输入题解标题"></el-input>
        </el-form-item>
        <el-form-item label="算法标签">
          <el-select filterable v-model="addForm.tagIds" multiple collapse-tags placeholder="请选择算法标签" clearable>
            <el-option v-for="item in tags" :key="item.id" :label="item.title" :value="item.id">
            </el-option>
          </el-select>

          <span style="margin-left:10px;margin-right:10px;">编程语言</span>

          <el-select v-model="addForm.languages" multiple collapse-tags placeholder="请选择编程语言" clearable>
            <el-option v-for="item in languagess" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
          <span style="margin-left:10px;margin-right:10px;">类型</span>

          <el-select v-model="addForm.sort_type" placeholder="请选择类型" clearable @change="$forceUpdate()">
            <el-option v-for="item in sortType" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>

        </el-form-item>

        <el-form-item label="内容" v-if="isShow">
          <!-- <Tinymce v-model="addForm.content"></Tinymce> -->
          <div class="md-box">
            <markdownShow @changeMardown="changeMardown" :markdown.sync="addForm.content" @SaveMarkDown="SaveMarkDown"></markdownShow>
          </div>
        </el-form-item>
        <el-form-item label="视频">
          <el-upload action="" :on-remove="handleRemove" :on-change="handleChangeFile" :auto-upload="false" :limit="3" :on-exceed="handleExceed" :file-list="fileList">
            <!-- 
            accept=""
            style="width: 400px" -->
            <i class="el-icon-circle-plus">
              <div slot="tip" class="el-upload__tip">
                上传视频
                <span>(请上传Ogg、WebM和MP4格式的视频)</span>
              </div>
            </i>
            <!-- <el-button size="small" type="primary">点击上传视频</el-button>
            <div slot="tip" class="el-upload__tip">
              只能上传mp4/avi文件，且不超过500MB
            </div> -->
          </el-upload>
          <!-- 视频组 -->
          <h4>视频预览区</h4>
          <div class="video-list">
            <video v-for="(videoItem, i) in fileList" :key="i" :src="videoItem.url" controls></video>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="submit('addForm')">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="更新类型" :visible.sync="dialogVisible1" width="30%">
      <el-form ref="addForm1" :model="addForm1" :rules="rules" size="small">
        <el-form-item label="类型">
          <el-select v-model="addForm1.sort_type" placeholder="请选择类型" clearable @change="$forceUpdate()">
            <el-option v-for="item in sortType" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="submit1">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  adminAddOrUpdateOjProblemAnalysis,
  adminGetOjProblemTagList,
  adminGetOjProblemAnalysisList,
  adminDeleteOjProblemAnalysis,
  adminUpdateOjProblemAnalysisSortType,
  adminUpdateOjProblemAnalysisVisible,
} from '@/api/adminOj.js'
// import Tinymce from '@/components/Tinymce'
import markdownShow from '@/components/markdownShow'
import uploadFile from '@/config/uploadFile'

export default {
  components: {
    // Tinymce,
    markdownShow,
  },
  data() {
    return {
      fileList: [],
      uploadFileTime: false,
      isShow: false,
      dialogTitle: '新增题解',
      oj_problem_analysis_id: '',
      addForm1: {},
      dialogVisible1: false,
      form: {},
      difficultyId: '',
      oj_problem_id: '',
      dialogVisible: false,
      addForm: {
        tagIds: [],
        title: '',
        languages: ['1'],
        oj_problem_id: '',
        content: '',
        sort_type: 1,
      },
      page_no: 1,
      page_size: 20,
      total: 20,
      tableData: [],
      tags: [],
      languagess: [
        {
          id: '0',
          name: 'C',
        },
        {
          id: '1',
          name: 'C++',
        },
        {
          id: '2',
          name: 'Python3',
        },
      ],
      sortType: [
        {
          id: 1,
          name: '官方',
        },
        {
          id: 2,
          name: '精选',
        },
        {
          id: 3,
          name: '普通',
        },
      ],
      rules: {
        title: [
          {
            required: true,
            message: '请输入标题',
            trigger: 'change',
          },
          {
            required: true,
            message: '请输入标题',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  created() {
    this.oj_problem_id = this.$route.query.oj_problem_id
    this.addForm.oj_problem_id = this.$route.query.oj_problem_id
  },
  mounted() {
    this.adminGetOjProblemAnalysisList()
    this.adminGetOjProblemTagList()
  },
  methods: {
    updateImages(row) {
      this.fileList = [
        {
          url: row.img_url,
          name: row.img_url.split('/')[row.img_url.split('/').length - 1],
        },
      ]
    },
    handleRemove(file, fileList) {
      this.fileList = fileList
    },
    handleExceed() {
      this.$message.warning(`只能上传3个视频，请删除后重新上传！`)
    },
    async handleChangeFile(file, fileList) {
      console.log(file, fileList)
      // const nameIndex = file.name.lastIndexOf('.')
      // const isAllowedType = ['.jpeg', '.png', '.jpg'].includes(
      //   file.name.substring(nameIndex)
      // )
      // // const isAllowedSize = file.size / 1024 < 500 // 小于500kb
      // const isAllowedSize = file.size / 1024 / 1024 < 2 // 小于2M

      // if (!isAllowedType) {
      //   this.$message.error('只能上传 JPG/PNG 格式的图片!')
      //   this.fileList.pop()
      // } else if (!isAllowedSize) {
      //   this.$message.error('上传的图片大小不能超过 2mb!')
      //   this.fileList.pop()
      // }
      // if (isAllowedType && isAllowedSize && !this.uploadFileTime) {
      //   await this.uploadFileOss(fileList)
      // }
      if (!this.uploadFileTime) {
        await this.uploadFileOss(fileList)
      }
    },
    async uploadFileOss(list) {
      console.log('uploadFileOss-list:', list)
      this.uploadFileTime = true
      await uploadFile(list, this.$store.state.user.userInfo.code).then(
        (res) => {
          console.log(res)
          // this.fileList = res
          // if (res && res.length > 0) {
          //   // this.ruleForm.highPictureUrl = res[0].name
          //   this.fileList.push({
          //     name: res[0].name,
          //     url: res[0].url,
          //   })
          // }
          this.fileList.push(res[res.length - 1])
          console.log('this.fileList:', this.fileList)
          this.uploadFileTime = false
        }
      )
    },
    //点击x关闭事件
    closeDialog(formName) {
      this.$refs[formName].resetFields()
      this.isShow = false

      this.dialogVisible = false
    },
    //是否可见
    changeType(row) {
      adminUpdateOjProblemAnalysisVisible({
        oj_problem_analysis_id: row.id,
        visible: row.visible,
      }).then(() => {
        this.$message.success('更新成功！')
      })
    },
    //更新类型
    editType(row) {
      this.addForm1.sort_type = row.sort_type
      this.oj_problem_analysis_id = row.id
      this.dialogVisible1 = true
    },
    submit1() {
      adminUpdateOjProblemAnalysisSortType({
        oj_problem_analysis_id: this.oj_problem_analysis_id,
        sort_type: this.addForm1.sort_type,
      }).then((res) => {
        console.log(res)
        this.dialogVisible1 = false

        this.$message.success('更新成功！')
        this.adminGetOjProblemAnalysisList()
      })
    },
    //查询
    search() {
      this.page_no = 1
      this.adminGetOjProblemAnalysisList()
    },
    //删除
    del(row) {
      this.$confirm('是否确认删除', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          adminDeleteOjProblemAnalysis({ id: row.id }).then(() => {
            this.$message({
              type: 'success',
              message: '删除成功!',
            })
            this.adminGetOjProblemAnalysisList()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消删除！',
          })
        })
    },
    //获得题目解析列表
    adminGetOjProblemAnalysisList() {
      adminGetOjProblemAnalysisList({
        ...this.form,
        problem_id: this.oj_problem_id,
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        console.log(res, 11)
        this.tableData = res.ojProblemAnalysisList
        this.tableData.map((res) => {
          console.log(res)
        })
      })
    },
    //算法标签列表
    adminGetOjProblemTagList() {
      adminGetOjProblemTagList({
        page_no: 1,
        page_size: 1000,
      }).then((res) => {
        this.tags = res.ojProblemTagList
      })
    },
    //新增题解
    AddTopicAnalysis() {
      this.isShow = true
      this.dialogTitle = '新增题解'
      this.dialogVisible = true
      this.adminGetOjProblemTagList()
    },
    //编辑
    edit(row) {
      this.isShow = true
      this.dialogTitle = '编辑题解'
      this.addForm.content = ''
      console.log(row.content)
      this.difficultyId = row.id
      this.addForm.tagIds = []
      this.addForm.title = row.title
      this.addForm.languages = JSON.parse(row.languages)
      this.addForm.content = row.content
      console.log(this.addForm.content)

      console.log("题解类型");
      console.log(row)


      this.addForm.sort_type = row.sort_type
      this.addForm1.sort_type = row.sort_type


      row.problemTagArr.map((item) => {
        this.addForm.tagIds.push(item.tagInfo.id)
      })
      if (row.video_url_arr) {
        this.fileList = []
        // 如果有视频
        const videoUrlArr = JSON.parse(row.video_url_arr)
        videoUrlArr.forEach((videoItemUrl) => {
          const nameIndex = videoItemUrl.lastIndexOf('/')
          this.fileList.push({
            name: videoItemUrl.slice(nameIndex + 1),
            url: videoItemUrl,
          })
        })
        console.log('row.video_url_arr:', row.video_url_arr)
        console.log(this.fileList)
      }
      this.dialogVisible = true
    },
    close() {
      // this.$refs["addForm"].resetFields();
      this.addForm.content = ''

      this.dialogVisible = false
      this.isShow = false
    },
    submit(formName) {
      const sendParams = JSON.parse(JSON.stringify(this.addForm))
      sendParams.languages = JSON.stringify(sendParams.languages)
      sendParams.tagIds = JSON.stringify(sendParams.tagIds)
      let videoList = []
      this.fileList.forEach((fileItem) => {
        videoList.push(fileItem.url)
      })
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.difficultyId) {
            console.log(123, 45)
            adminAddOrUpdateOjProblemAnalysis({
              id: this.difficultyId,
              ...sendParams,
              videoUrlArr: JSON.stringify(videoList),
            }).then(() => {
              this.$message.success('修改成功!')
              this.close()
              this.adminGetOjProblemAnalysisList()
            })
          } else {
            adminAddOrUpdateOjProblemAnalysis({
              ...sendParams,
              videoUrlArr: JSON.stringify(videoList),
            }).then(() => {
              this.$message.success('添加成功!')
              this.close()
              this.adminGetOjProblemAnalysisList()
            })
          }
        }
      })
    },

    goback() {
      this.$router.go(-1)
    },
    handleCurrent(val) {
      this.page_no = val
      this.adminGetOjProblemAnalysisList()
    },
    changeMardown(val) {
      console.log(val)
      this.addForm.content = val
    },
    SaveMarkDown(md, html) {
      console.log('md:', md)
      console.log('html:', html)
      this.addForm.content = md
    },
  },
}
</script>
<style lang="scss" scoped>
.problem {
  height: 100%;
  width: 100%;
}

.topTitle {
  height: 60px;
  background: #fff;
  margin: 10px;
  cursor: pointer;

  padding: 20px;
  border-radius: 5px;
  box-sizing: border-box;
  font-size: 14px;

  span {
    color: rgba(0, 0, 0, 0.45);
  }
}

.mian {
  margin: 10px;
  background: 10px;
  padding: 20px;
  background: #fff;
  border-radius: 5px;
  box-sizing: border-box;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.clearfix:after {
  content: "";
  display: block;
  visibility: hidden;
  clear: both;
}
/deep/ .el-upload {
  width: 100%;
  i.el-icon-circle-plus {
    box-sizing: border-box;
    width: 100%;
    padding: 8px;
    vertical-align: middle;
    border: 1px solid #666;
    border-radius: 5px;
    font-size: 18px;
    color: #2488ef;
  }
}
/deep/ .el-upload-list {
  display: flex;
  align-items: center;
  .el-upload-list__item {
    width: 30%;
    margin-right: 15px;
    &:last-child {
      margin-right: 0;
    }
  }
}
.video-list {
  display: flex;
  align-items: center;
  video {
    width: 30%;
    height: 200px;
    margin-right: 15px;
    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
